import React, { useEffect, useState } from 'react'
import { fetchKPIStatsCombined } from '../graphQL'
import { formatStats, getDefaultRanges, prepareRange } from '../util'
import StatsKPIView from '../component/StatsKPIView'
import CityPage from 'Containers/City/Page'

const StatsKPI = ({ cityId, ...props }) => {
  const { firstRangeDefault, secondRangeDefault } = getDefaultRanges()
  const [tablesData, setTablesData] = useState([])
  const [firstRange, setFirstRangeDates] = useState(firstRangeDefault)
  const [secondRange, setSecondRangeDates] = useState(secondRangeDefault)

  // Cleanup on unmount
  useEffect(() => () => setTablesData([]), [])

  useEffect(() => {
    updateData(prepareRange(firstRange), prepareRange(secondRange))
  }, [firstRange, secondRange])

  const updateData = async (firstRange, secondRange) => {
    const {
      firstStats,
      secondStats,
      currentStats,
    } = await fetchKPIStatsCombined({
      firstRange,
      secondRange,
      cityId,
    })

    const formattedStats = formatStats(
      {
        ...firstRange,
        stats: firstStats,
      },
      {
        ...secondRange,
        stats: secondStats,
      },
      currentStats,
    )
    setTablesData(formattedStats)
  }

  return (
    <CityPage
      active={props.nav}
      cityId={cityId}
      history={props.history}
      match={props.match}
      cityName={props.cityName}
      breadcrumbs={[
        {
          label: 'Stats',
        },
      ]}
    >
      <StatsKPIView
        tablesData={tablesData}
        setFirstRangeDates={setFirstRangeDates}
        setSecondRangeDates={setSecondRangeDates}
        firstRange={firstRange}
        secondRange={secondRange}
      />
    </CityPage>
  )
}

export default StatsKPI
